import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputMask from "react-input-mask";

const useStyles = makeStyles(error => ({
  container: {
    width: "100%",
    marginTop: 10,
    "& .MuiInput-underline:after": {
      color: error ? "#D0101B" : "#778899",
    },
    "& > .MuiInputLabel-root": {
      color: "#778899",
      fontSize: 14
    },
    "& > .MuiInputLabel-root > .MuiInputLabel-asterisk": {
      color: "#E95356"
    },
    "& > .MuiInputBase-root": {
      fontSize: 12
    }
  }
}));

const TextField = props => {
  const [triggered, setTFT] = React.useState(false);
  const [errorMessage, setErrorMesssage] = React.useState(null);
  const { container } = useStyles(!!errorMessage);

  useEffect(() => {
    if (props.required && !props.value && triggered) {
      setErrorMesssage(props.errorMessage || "Обязательное поле");
    }
    setTFT(true)
  }, [props.value]);

  return (
    <FormControl required={props.required} helpertext={errorMessage} className={container}>
      <InputLabel shrink>{props.label}</InputLabel>
      {props.mask ? (
        <InputMask {...props}>{() => <Input />}</InputMask>
      ) : (
        <Input {...props} error={!!errorMessage} />
      )}
    </FormControl>
  );
};

export default TextField;
